module.exports = __webpack_public_path__ + "media/images/pagetop_arrow-33da10723dfdcde20fd7f71324b5ad32.png";